import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import colors from 'styles/colors';
import { Inner } from 'styles/structure';
import { Rubric } from 'styles/typography';
import Slideshow from 'components/Slideshow';

const EventsWebinarsContainer = styled.div`
  background-color: ${colors.orange100};
  padding: 6.4rem 0 4rem;
  
  header {
    text-align: center;
    margin-bottom: 4rem;
  }
  
  & + * {
    margin-top: 6.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 10.4rem 0;
    
    header {
      margin-bottom: 8.8rem;
    }
    
    & + * {
      margin-top: 12rem;  
    }
  }
`;

const EventsWebinars = ({ slides, heading, intro, delay }) => {
  return (
    <EventsWebinarsContainer>
      <Inner>
        <header>
          {intro && <Rubric>{intro}</Rubric>}
          {heading && <h2>{heading}</h2>}
        </header>

        <Slideshow
          duration={delay}
          slides={slides}
          variant='events'
        />
      </Inner>
    </EventsWebinarsContainer>
  );
};

export default EventsWebinars;
